import React from 'react';
import { Container, WrapperContentCard } from './styles';
import { performCard } from '../../../../../utils/mountAreaVariationCards';
import { IAreaVariationCard, IParsedDataCard, nameProps } from '../../../../../types';
import { VariationSection } from '@/global/components/AreaVariationBest/SectionCardVariation';
import { TitleContainer } from '@/global/components/AreaVariationBest/SectionCardVariation/styles';

interface IProps {
  name: nameProps;
  data: IAreaVariationCard;
  title?: string;
}

export const VariationCard: React.FC<IProps> = ({ title, data, name }) => {
  const parsedDataCard = React.useMemo(() => performCard(data, name), [data]) as IParsedDataCard;
  return (
    <Container>
      {title && <TitleContainer>
        <h4>{title}</h4>
      </TitleContainer>}
      <WrapperContentCard>
        <VariationSection data={parsedDataCard} />
      </WrapperContentCard>
    </Container>
  );
};
